"use client"

import { Button, DialogTrigger } from "@abraxas/ui/ui"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@abraxas/ui/ui"
import React, { useState } from "react"
import { ProductWithListing } from "./types"
import { ListingView } from "./ListingView"

interface ViewProductProps {
  product: ProductWithListing
  className?: string
}

export const ViewProduct: React.FC<ViewProductProps> = ({
  product,
  className = "",
}) => {
  return (
    <Dialog>
        <DialogTrigger asChild>
          <Button size="small" className={className} >
            View Details
          </Button>
        </DialogTrigger>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Product Details</DialogTitle>
          </DialogHeader>
          <ListingView product={product} />
        </DialogContent>
      </Dialog>
  )
}
